import type { FormName, ModalName } from '@coursera/event-pulse-types';
import { createTrackerStore } from '@coursera/event-pulse/react';

type AuthModalData = {
  modalName: ModalName;
  formName?: FormName;
};

export const [AuthModalTrackerContextProvider, useAuthModalTrackerContext] = createTrackerStore<AuthModalData>();
